import { render } from "./FileSelector.vue?vue&type=template&id=17f6ab06&scoped=true"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"

import "./FileSelector.vue?vue&type=style&index=0&id=17f6ab06&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f6ab06"]])

export default __exports__